import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { MeteringPointDto, MeteringPointService } from '@app/api/dmc';
import { ModalService } from '@app/core/services/modal.service';
import {
  editMeteringPointModalConfig
} from '@shared/modals/meteringpoint/edit-meteringpoint-modal/edit-meteringpoint-modal-config';
import {
  EditRejectedMeteringpointModalComponent
} from '@shared/modals/meteringpoint/edit-rejected-meteringpoint-modal/edit-rejected-meteringpoint-modal.component';

@Injectable({
  providedIn: 'root'
})
export class EditMeteringPointModalService {
  constructor(
    private readonly modalService: ModalService,
    private readonly meteringPointService: MeteringPointService,
  ) {}

  /**
   * Opens the edit modal matching the metering point's DataHub state:
   * a regular update (E32) when it exists in DataHub, otherwise a resend of the create request (E02).
   */
  public open(identification: string): Observable<any> {
    return this.meteringPointService.meteringPointGetByIdentificationGet(identification).pipe(
      switchMap((meteringPointDTO: MeteringPointDto) => this.openFor(meteringPointDTO))
    );
  }

  public openFor(meteringPointDTO: MeteringPointDto): Observable<any> {
    if (meteringPointDTO.existsInDataHub) {
      return this.modalService.show({
        ...editMeteringPointModalConfig,
        params: { id: meteringPointDTO.identification }
      });
    }

    return this.modalService.show({
      component: EditRejectedMeteringpointModalComponent,
      title: 'meteringPoint.edit.title',
      size: 'xl',
      actions: [
        { type: 'primary', label: 'system.button.update', method: 'submit' },
        { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
      ],
      params: { meteringPointDTO }
    });
  }
}
